type PropsType = {
  styles?: object;
  fill?: string;
  stroke?: string;
};

const BedroomIcon = ({ styles, fill, stroke }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M6 5.91211H18C18.5233 5.91211 18.9687 6.09764 19.3418 6.4707C19.7149 6.84377 19.9004 7.28923 19.9004 7.8125V10.9121H20C20.5233 10.9121 20.9687 11.0976 21.3418 11.4707C21.7149 11.8438 21.9004 12.2892 21.9004 12.8125V17.7129H20.5771L20.5547 17.7812L19.9277 19.7129H19.0723L18.4453 17.7812L18.4229 17.7129H5.57715L5.55469 17.7812L4.92773 19.7129H4.07227L3.44531 17.7812L3.42285 17.7129H2.09961V12.7871C2.0997 12.2641 2.28503 11.8233 2.65723 11.459C3.03013 11.094 3.47604 10.9121 4 10.9121H4.09961V7.8125C4.09961 7.28923 4.28514 6.84377 4.6582 6.4707C5.03127 6.09764 5.47673 5.91211 6 5.91211ZM3.90039 15.9121H20.0996V12.7129H3.90039V15.9121ZM5.90039 10.9121H11.0996V7.71289H5.90039V10.9121ZM12.9004 10.9121H18.0996V7.71289H12.9004V10.9121Z"
        fill="#5B6573"
        stroke="white"
        stroke-width="0.2"
      />
    </svg>
  );
};
export default BedroomIcon;
